// extracted by mini-css-extract-plugin
module.exports = {"collapseHeader":"styles_collapseHeader__2QoZz"};